{
  "messages": [],
  "pipeData": {
    "get.contract.detail": {
      "messages": [],
      "data": [
        {
          "id": 2002,
          "contractIdentifier": "BM-CTR-0042",
          "partnerDtoName": "Allianz",
          "productDtoName": "Hausratversicherung",
          "startDate": "2022-06-15",
          "endDate": null,
          "baseStatusEnumName": "ACTIVE"
        }
      ]
    },
    "get.contract.payment.account": {
      "messages": [],
      "data": [
        {
          "billingAreaDtoName": "Quarterly",
          "frequencyEnumName": "QUARTERLY",
          "currency": "EUR",
          "paymentTiming": "IN_ARREARS",
          "paymentDayOfMonth": "D15",
          "paymentMethod": "SEPA_DIRECT_DEBIT",
          "startDate": "2022-01-01",
          "endDate": null,
          "closed": false,
          "bankAccountName": "Julia Weber JW3K9P2A1",
          "iban": "DE44500105175407324931"
        },
        {
          "billingAreaDtoName": "Quarterly",
          "frequencyEnumName": "QUARTERLY",
          "currency": "EUR",
          "paymentTiming": "IN_ARREARS",
          "paymentDayOfMonth": "D15",
          "paymentMethod": "SEPA_TRANSFER",
          "startDate": "2020-01-01",
          "endDate": "2021-12-31",
          "closed": false,
          "bankAccountName": "Julia Weber (Business)",
          "iban": "DE12500105170648489890"
        },
        {
          "billingAreaDtoName": "Quarterly",
          "frequencyEnumName": "QUARTERLY",
          "currency": "EUR",
          "paymentTiming": "IN_ARREARS",
          "paymentDayOfMonth": "D15",
          "paymentMethod": "CASH",
          "startDate": "2019-01-01",
          "endDate": "2016-12-31",
          "closed": true,
          "bankAccountName": "Old Account (Closed)",
          "iban": "DE00000000000000000000"
        }
      ]
    },
    "get.contract.price.history": {
      "messages": [],
      "data": [
        {
          "startDate": "2022-06-15",
          "priceFrequencyDtoName": "Quarterly",
          "priceGross": 27.5,
          "currency": "EUR"
        },
        {
          "startDate": "2023-07-01",
          "priceFrequencyDtoName": "Quarterly",
          "priceGross": 29.9,
          "currency": "EUR"
        },
        {
          "startDate": "2024-01-01",
          "priceFrequencyDtoName": "Quarterly",
          "priceGross": 31.2,
          "currency": "EUR"
        }
      ]
    },
    "get.contract.payment.planned.entries": {
      "messages": [],
      "data": [
        {
          "contractDtoId": 2002,
          "contractDtoName": "BM-CTR-0042",
          "startDate": "2025-01-15",
          "endDate": "2025-01-15",
          "dueDate": "2025-01-15",
          "plannedTypeDtoName": "Beitrag: SEPA gescheitert",
          "status": "DEBIT",
          "amount": 31.2,
          "remainingAmount": 31.2,
          "currency": "EUR"
        },
        {
          "contractDtoId": 2002,
          "contractDtoName": "BM-CTR-0042",
          "startDate": "2025-01-16",
          "endDate": "2025-01-16",
          "dueDate": "2025-01-16",
          "plannedTypeDtoName": "Bankrücklaufgebühr",
          "status": "DEBIT",
          "amount": 5.95,
          "remainingAmount": 37.15,
          "currency": "EUR"
        },
        {
          "contractDtoId": 2002,
          "contractDtoName": "BM-CTR-0042",
          "startDate": "2025-02-03",
          "endDate": "2025-02-03",
          "dueDate": "2025-02-03",
          "plannedTypeDtoName": "Überweisung (Teilzahlung)",
          "status": "CREDIT",
          "amount": 20.0,
          "remainingAmount": 17.15,
          "currency": "EUR"
        },
        {
          "contractDtoId": 2002,
          "contractDtoName": "BM-CTR-0042",
          "startDate": "2025-02-10",
          "endDate": "2025-02-10",
          "dueDate": "2025-02-10",
          "plannedTypeDtoName": "Mahnung",
          "status": "DEBIT",
          "amount": 3.5,
          "remainingAmount": 20.65,
          "currency": "EUR"
        },
        {
          "contractDtoId": 2002,
          "contractDtoName": "BM-CTR-0042",
          "startDate": "2025-03-01",
          "endDate": "2025-03-01",
          "dueDate": "2025-03-01",
          "plannedTypeDtoName": "Überweisung",
          "status": "CREDIT",
          "amount": 20.65,
          "remainingAmount": 0.0,
          "currency": "EUR"
        }
      ]
    }
  }
}
